export const games = [
  {
    id: 1, title: "BlockQuest Miner's ⛏️",
    description: "Dig deep, mine blocks, and discover how blockchain mining really works — one block at a time!",
    url: "https://block-quest-miners-game-dq2b.vercel.app/",
    theme: "rainbow", emojis: ["⛏️", "💎", "🪨", "⚡", "🔗"], comingSoon: false,
    preview: "https://static.prod-images.emergentagent.com/jobs/d8dff59b-4fda-48a1-a05d-f027b59837f6/images/abc5f9a5cbaa4c3728a6a34a8a5a907c6a7a9f245b01438925d2383e4a78a7e3.png"
  },
  {
    id: 2, title: "Web3 Wallet Adventure 💼",
    description: "Learn how digital wallets work — store, send, and protect your crypto in a fun adventure with Gerry!",
    url: "https://web3-wallet-adventure.vercel.app/",
    theme: "rainbow", emojis: ["💼", "🔐", "💰", "🌐", "⚡"], comingSoon: false,
    preview: "https://static.prod-images.emergentagent.com/jobs/d8dff59b-4fda-48a1-a05d-f027b59837f6/images/971ae42240e3f49c35cc44b9eb3bed87e16298cccd627eb9236d348b84ce7c60.png"
  },
  {
    id: 3, title: "BlockQuest Retro Arcade 🎮",
    description: "Join Zara, Sam, Miko, Ollie & Lila as they turn Web3 chaos into playable levels!",
    url: "https://block-quest-retro-arcade-v1-2026.vercel.app/",
    theme: "rainbow", emojis: ["🎮", "⬡", "🏆", "⚡", "💎"], comingSoon: false,
    preview: "https://customer-assets.emergentagent.com/job_d8dff59b-4fda-48a1-a05d-f027b59837f6/artifacts/0llvbuko_retroarcadeplaceholder.jpg"
  },
  {
    id: 4, title: "NFT Creation Studio 🎨",
    description: "Design, mint, and showcase your own NFT art — learn what makes digital creations unique and valuable!",
    url: "https://block-quest-nft-creation-studio.vercel.app/",
    theme: "rainbow", emojis: ["🎨", "🖼️", "✨", "💎", "🐐"], comingSoon: false,
    preview: "https://static.prod-images.emergentagent.com/jobs/d8dff59b-4fda-48a1-a05d-f027b59837f6/images/3c650dd9b9cd0764ad30b5a0b278a599532ad15ace4d6e891b76b34882b5f1b1.png"
  }
];
